module.exports = "<p>\r\n  machine-monitoring works!\r\n</p>\r\n"